import { render, staticRenderFns } from "./DomainSecurityConnection.vue?vue&type=template&id=315b7a69&scoped=true&"
import script from "./DomainSecurityConnection.vue?vue&type=script&lang=ts&"
export * from "./DomainSecurityConnection.vue?vue&type=script&lang=ts&"
import style0 from "./DomainSecurityConnection.vue?vue&type=style&index=0&id=315b7a69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b7a69",
  null
  
)

export default component.exports